export default "__VITE_ASSET__BbXX347K__"